import type { Permission } from '@server/permissions';
import type { GetStartedDto } from '../components/pages/get-started/getStartedTypes';
import type { AccountOnboardingStep } from '@server/account-onboarding';
import type { PlanFeature } from '@server/plan';
import type { AccountType } from '@server/account-type';
import type { QuestionnaireDto } from '../components/pages/questionnaire/questionnaireTypes';
import type { UserPreferencesTableColumnSettings } from '@server/user-preferences';

export type Emoji = {
  content: string;
  bgColor: string;
};

export enum InviteeStatus {
  InviteeStatusPending = 'PENDING',
  InviteeStatusExpired = 'EXPIRED',
}

export enum Template {
  Funnel = 'FUNNEL',
  Account = 'ACCOUNT',
}

export interface InviteeInfo {
  invitee: string;
  roleGroupId: string;
  status: InviteeStatus;
  template: Template;
  message?: string;
  entryPointName?: string;
  entryPointId?: string;
}

export interface UserPreferences {
  getStarted?: GetStartedDto;
  defaultCreationCrmOrgId?: string | null;
  questionnaire?: QuestionnaireDto;
  tableColumnSettings?: UserPreferencesTableColumnSettings[];
}

export interface UserInfo {
  id?: string;
  canResetPassword?: boolean;
  name?: string;
  imageUrl?: string;
  jobTitle?: string;
  email?: string;
  account?: {
    id?: string;
    name?: string;
    authZeroOrgId?: string;
    onboardingStep?: AccountOnboardingStep;
    type?: AccountType;
    trialStartDate?: string;
    trialEndDate?: string;
    disableAi?: boolean;
    planFeatures?: PlanFeature[];
    isBuildModeEnabled?: boolean;
  };
  roleGroupId?: string;
  emoji?: Emoji;
  orgPermissions?: Record<string, Permission[]>;
  accountPermissions?: Permission[];
  status?: UserStatus;
  preferences?: UserPreferences;
  mcpOrgId?: string;
}

export enum UserStatus {
  Inactive = 'INACTIVE',
  Active = 'ACTIVE',
}

export interface AccountUsersData {
  invitations?: InviteeInfo[];
  users?: UserInfo[];
}

export type ClearbitEnrichment = {
  person: Record<string, any>;
  company: Record<string, any>;
};
